import DashboardHeader from "../../headers/DashboardHeader";

export default function PrivacyPolicy() {
  return (
    <>
      <div className="header-container">
        <DashboardHeader />
      </div>
      <div
        className="container"
        style={{
          maxWidth: "900px",
          margin: "0 auto",
          padding: "20px",
          overflowY: "scroll",
          maxHeight: "calc(100vh - 90px)",
          marginBottom: "20px",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        <div
          className="card"
          style={{
            padding: "2rem",
            boxShadow: "0 2px 12px rgba(0,0,0,0.1)",
          }}
        >
          {/* Title */}
          <h2 className="text-center primary-color">Privacy Policy</h2>
          <h3 className="text-center mb-4">Little Haiti Global</h3>

          {/* Intro */}
          <p>
            Welcome to the Privacy Policy of Little Haiti Global Inc. (
            <strong>“LHG,” “we,” “us,” or “our” </strong>). This Privacy Policy
            applies to your access to and use of the Little Haiti Global Project
            Portal (the <b>“Portal”</b>) and the related features, content,
            tools, applications, and services offered through the Portal
            (collectively, the <b>“Services”</b>) in connection with the Little
            Haiti Global relocation and investment initiative (the{" "}
            <b>“Program”</b>).
          </p>
          <p>
            This Privacy Policy explains how LHG collects, uses, stores,
            processes, and discloses your Personal Information when you access
            the Portal, use the Services, or otherwise interact with us. It also
            describes your rights and choices regarding your Personal
            Information, as well as how you can contact us.
          </p>
          <p>
            By creating an Account, accessing the Portal, or using the Services,
            you acknowledge that you have read, understood, and agree to the
            collection, use, and disclosure of your Personal Information in
            accordance with this Privacy Policy and applicable law.
          </p>

          {/* Section 1 */}
          <h5 className="fw-bold mt-4 mb-2">1. Scope of this Privacy Policy</h5>
          <p className="mb-1">This Privacy Policy applies to:</p>
          <ul
            style={{
              listStyleType: "none",
              paddingLeft: "0",
            }}
          >
            <li>
              (i) all Personal Information collected through the Portal and the
              Services from individual persons, companies, organizations,
              applicants, investors, representatives, and any Authorized Users
              participating in the Program; and
            </li>
            <li>
              (ii) any Personal Information collected through offline
              interactions related to your participation in the Program, to the
              extent such information is processed in connection with the Portal
              and the Services.
            </li>
          </ul>
          <p>
            This Privacy Policy does not apply to Third-Party Sites (as defined
            in the Terms of Use) that may be linked to or accessible from the
            Portal. LHG is not responsible for the privacy practices of such
            Third-Party Sites.
          </p>
          <p>
            For the avoidance of doubt, where you authorize a representative,
            agent, attorney-in-fact, or other third party (collectively, an
            <strong> “Authorized Representative”</strong>) to act on your behalf
            in connection with the Portal, the Services, or the Program, you are
            responsible for ensuring that such Authorized Representative is
            aware of, understands, and complies with this Privacy Policy and all
            applicable laws. Any actions taken by an Authorized Representative
            on your behalf shall be deemed to be your actions for purposes of
            this Privacy Policy, and you remain responsible and liable for any
            breach of this Privacy Policy caused by such Authorized
            Representative.
          </p>

          {/* Section 2 */}
          <h5 className="fw-bold mt-4 mb-2">2. Definitions</h5>
          <p>
            Capitalized terms used in this Privacy Policy and not otherwise
            defined herein shall have the meanings ascribed to them in the Terms
            of Use.
          </p>
          <p>For purposes of this Privacy Policy:</p>
          <ul
            style={{
              listStyleType: "none",
              paddingLeft: "0",
            }}
          >
            <li>
              (i) <strong>“Personal Information”</strong> means any information
              relating to an identified or identifiable natural person, as
              defined under applicable law;
            </li>
            <li>
              (ii) <strong>“Processing”</strong> means any operation or set of
              operations performed on Personal Information, whether or not by
              automated means, including collection, recording, organization,
              storage, adaptation, retrieval, consultation, use, disclosure,
              dissemination, alignment, combination, restriction, erasure, or
              destruction;
            </li>
            <li>
              (iii) <strong>“Sensitive Personal Information”</strong> means
              Personal Information revealing racial or ethnic origin, political
              opinions, religious or philosophical beliefs, trade union
              membership, genetic or biometric data, data concerning health,
              sexual orientation, or other categories defined as sensitive or
              special category data under applicable law;
            </li>
            <li>
              (iv) <strong>“Third-Party Sites”</strong> means websites,
              applications, or online services operated by unaffiliated
              entities; and
            </li>
            <li>
              (v) <strong>“Anonymized Data”</strong> means data that has been
              modified so it can no longer reasonably be used to identify an
              individual, directly or indirectly.
            </li>
          </ul>

          {/* Section 3 */}
          <h5 className="fw-bold mt-4 mb-2">3. Information We Collect</h5>
          <p>
            Depending on your relationship with LHG and your use of the Portal
            and Services, we may collect the following categories of Personal
            Information:
          </p>

          <h5 className="fw-bold mt-3">A. Information You Provide Directly</h5>
          <ul
            style={{
              listStyleType: "none",
              paddingLeft: "0",
            }}
          >
            <li>
              (i) Identification and contact information, such as your name,
              date of birth, address, telephone number, email address, mailing
              address, and government-issued identification numbers;
            </li>
            <li>
              (ii) Program application information, such as your relocation and
              investment application details, responses to application or
              eligibility forms, background documents, investment preferences,
              and supporting documentation;
            </li>
            <li>
              (iii) Payment and financial information, such as bank account
              details, credit or debit card information, wire transfer details,
              and transaction history, as required to process payments in
              connection with the Program;
            </li>
            <li>
              (iv) Communications, such as messages sent through the Portal’s
              secure messaging system, emails, SMS messages, or other
              correspondence with LHG, including communications exchanged with
              our support team or project staff; and
            </li>
            <li>
              (v) Compliance documentation, such as background check
              authorizations, proof of funds, anti-money laundering (AML)
              documentation, and sanctions screening results.
            </li>
          </ul>

          <h5 className="fw-bold mt-3">
            B. Information Collected Automatically
          </h5>
          <ul
            style={{
              listStyleType: "none",
              paddingLeft: "0",
            }}
          >
            <li>
              (i) Device and usage information, including IP address, browser
              type, operating system, device identifiers, and activity logs
              related to your use of the Portal;
            </li>
            <li>
              (ii) Log and analytics data, such as pages viewed, time spent on
              the Portal, access times, and referring URLs; and
            </li>
            <li>
              (iii) Cookies and similar technologies, as further described in
              Section 5 (Cookies and Tracking Technologies).
            </li>
          </ul>

          <h5 className="fw-bold mt-3">C. Information from Third Parties</h5>
          <ul
            style={{
              listStyleType: "none",
              paddingLeft: "0",
            }}
          >
            <li>
              (i) Government authorities or agencies, for identity verification
              or compliance purposes;
            </li>
            <li>
              (ii) Financial institutions or payment processors, for payment
              facilitation and fraud prevention;
            </li>
            <li>
              (iii) Referral sources, authorized representatives, or other
              Program participants who provide information on your behalf; and
            </li>
            <li>(iv) Publicly available sources, where permitted by law.</li>
          </ul>
          {/* Section 4 */}
          <h5 className="fw-bold mt-4 mb-2">4. Lawful Basis for Processing</h5>
          <p>
            LHG processes your Personal Information only where permitted by
            applicable law, including:
          </p>
          <ul
            style={{
              listStyleType: "none",
              paddingLeft: "0",
            }}
          >
            <li>
              (i) <strong>Contractual necessity:</strong> to perform our
              obligations under the Terms of Use or other agreements with you;
            </li>
            <li>
              (ii) <strong>Legal obligations:</strong> to comply with applicable
              laws, regulations, court orders, or law enforcement requests,
              including AML/CTF requirements;
            </li>
            <li>
              (iii) <strong>Legitimate interests:</strong> to operate, maintain,
              and improve the Portal and Services; prevent fraud and abuse;
              secure our systems; and protect our legal rights;
            </li>
            <li>
              (iv) <strong>Consent:</strong> where you have given clear and
              informed consent to the Processing of your Personal Information
              for specific purposes; and
            </li>
            <li>
              (v) <strong>Vital interests:</strong> to protect your safety or
              the safety of others.
            </li>
          </ul>

          {/* Section 5 */}
          <h5 className="fw-bold mt-4 mb-2">
            5. Cookies and Tracking Technologies
          </h5>

          <h5 className="fw-bold mt-3">A. Cookies and Tracking</h5>
          <p>
            The Portal may use cookies, pixel tags, local storage, and other
            tracking technologies to:
          </p>
          <ul
            style={{
              listStyleType: "none",
              paddingLeft: "0",
            }}
          >
            <li>(i) Enable core functionality of the Portal;</li>
            <li>(ii) Remember your preferences and settings;</li>
            <li>(iii) Analyze usage and performance;</li>
            <li>(iv) Deliver relevant content and communications; and</li>
            <li>
              (v) Detect and prevent fraudulent or unauthorized activities.
            </li>
          </ul>
          <p>
            You may configure your browser to block or delete cookies, but doing
            so may impair the functionality of the Portal or your ability to use
            certain features. Where required by applicable law, we will obtain
            your consent before placing non-essential cookies or similar
            technologies on your device.
          </p>

          <h5 className="fw-bold mt-3">
            B. Third-Party Cookies and Tracking by Partners
          </h5>
          <p>
            In addition to LHG’s use of cookies and similar technologies
            described in Section 5, certain third-party analytics, advertising,
            or content providers (<strong>“Third-Party Partners”</strong>) may
            place cookies, pixel tags, or similar tracking technologies on your
            device when you access or use the Portal. These technologies may
            collect information about your online activities over time and
            across different websites, applications, or online services,
            including device identifiers, browsing history, and usage data.
          </p>
          <p>
            Such Third-Party Partners may use this information to provide
            analytics services, deliver targeted content, measure the
            effectiveness of their content or advertising, and for other
            purposes described in their respective privacy policies. LHG does
            not control the tracking technologies used by these third parties,
            and their use is subject to their own terms and privacy policies.
          </p>
          <p>
            Where required by applicable law, LHG will obtain your consent
            before allowing Third-Party Partners to place non-essential cookies
            or similar technologies on your device. You may also manage or
            disable such tracking through your browser settings or by using
            opt-out tools provided by the relevant third-party services. LHG
            does not have access to or control over the information collected by
            these Third-Party Partners, and their activities are subject solely
            to their own terms and privacy policies.
          </p>

          {/* Section 6 */}
          <h5 className="fw-bold mt-4 mb-2">
            6. Sensitive Personal Information
          </h5>
          <p>
            Where required by law or where necessary for the purposes of the
            Program, LHG may collect and process Sensitive Personal Information,
            including for:
          </p>
          <ul
            style={{
              listStyleType: "none",
              paddingLeft: "0",
            }}
          >
            <li>(i) Compliance with legal requirements;</li>
            <li>(ii) Conducting due diligence and background checks;</li>
            <li>(iii) Assessing eligibility for Program participation; and</li>
            <li>(iv) Fulfilling contractual obligations under the Program.</li>
          </ul>
          <p>
            We will process Sensitive Personal Information only with your
            explicit consent or where otherwise permitted or required by
            applicable law, and will apply enhanced safeguards to protect such
            data.
          </p>

          {/* Section 7 */}
          <h5 className="fw-bold mt-4 mb-2">7. Your Privacy Rights</h5>
          <p>
            Depending on your jurisdiction, you may have the following rights in
            relation to your Personal Information:
          </p>
          <ul
            style={{
              listStyleType: "none",
              paddingLeft: "0",
            }}
          >
            <li>
              (i) The right to access and obtain a copy of your Personal
              Information;
            </li>
            <li>
              (ii) The right to correct inaccurate or incomplete Personal
              Information;
            </li>
            <li>
              (iii) The right to delete your Personal Information (the “right to
              be forgotten”);
            </li>
            <li>
              (iv) The right to restrict or object to certain Processing
              activities;
            </li>
            <li>
              (v) The right to data portability, to receive your Personal
              Information in a structured, commonly used, and machine-readable
              format;
            </li>
            <li>
              (vi) The right to withdraw consent where Processing is based on
              consent, without affecting the lawfulness of Processing prior to
              such withdrawal.
            </li>
          </ul>
          <p>
            Requests to exercise these rights should be submitted to{" "}
            <a className="fw-bold" href="mailto:privacy@littlehaitiglobal.com">
              privacy@littlehaitiglobal.com
            </a>
            , and LHG will respond in accordance with applicable law. This
            includes the right to opt out of receiving direct marketing
            communications, as further described in Section 8(B).
          </p>

          {/* Section 7A */}
          <h5 className="fw-bold mt-3">
            7A. Withdrawal of Consent and Service Impact
          </h5>
          <p>
            Where the Processing of your Personal Information is based on your
            consent, you may withdraw that consent at any time by contacting us
            at{" "}
            <a className="fw-bold" href="mailto:privacy@littlehaitiglobal.com">
              privacy@littlehaitiglobal.com
            </a>{" "}
            or through any other method provided by LHG. Withdrawal of consent
            will not affect the lawfulness of any Processing carried out prior
            to such withdrawal.
          </p>
          <p>
            You acknowledge that certain Processing activities are necessary for
            your participation in the Program and for your access to and use of
            the Portal and Services. If you withdraw consent for Processing that
            is essential to the provision of the Services, LHG may be unable to
            continue providing you with those Services, and your participation
            in the Program may be suspended or terminated, subject to applicable
            law and any applicable contractual obligations.
          </p>

          {/* Section 8 */}
          <h5 className="fw-bold mt-4 mb-2">
            8. How We Use Personal Information
          </h5>

          <h5 className="fw-bold mt-3">A. Use</h5>
          <p>
            We may use the Personal Information we collect for the following
            purposes:
          </p>
          <ul
            style={{
              listStyleType: "none",
              paddingLeft: "0",
            }}
          >
            <li>
              (i) <strong>Program Administration:</strong> to receive, process,
              evaluate, and manage relocation and investment applications;
              maintain User Accounts; and facilitate your participation in the
              Program;
            </li>
            <li>
              (ii) <strong>Service Delivery:</strong> to operate, provide,
              maintain, and improve the Portal and the Services, including
              providing secure access to personalized dashboards, case tracking,
              and secure communications;
            </li>
            <li>
              (iii) <strong>Payment Processing:</strong> to process fees,
              contributions, and other payments; issue confirmations and
              receipts; manage billing; and address payment disputes;
            </li>
            <li>
              (iv) <strong>Compliance and Risk Management:</strong> to conduct
              due diligence, background checks, sanctions screening, and other
              activities required under applicable laws, including anti-money
              laundering (AML) and counter-terrorist financing (CTF)
              obligations;
            </li>
            <li>
              (v) <strong>Communications:</strong> to send notices, updates,
              alerts, decisions, required actions, and other messages related to
              the Program or the Services, whether through the Portal, email,
              SMS, or other electronic means;
            </li>
            <li>
              (vi) <strong>Security and Fraud Prevention:</strong> to monitor,
              detect, investigate, and prevent fraud, unauthorized access, or
              other malicious or unlawful activity; and to enhance the security
              and performance of the Portal;
            </li>
            <li>
              (vii) <strong>Legal and Regulatory Purposes:</strong> to comply
              with applicable laws, respond to lawful requests from public
              authorities, and protect our legal rights;
            </li>
            <li>
              (viii) <strong>Research and Analytics:</strong> to evaluate the
              performance of the Program and Services, conduct market and
              demographic research, and improve user experience, provided such
              use complies with applicable privacy laws.
            </li>
          </ul>
          <h5 className="fw-bold mt-3">B. Marketing and Opt-Out Rights</h5>
          <p>
            Where permitted by applicable law, LHG may use your Personal
            Information to send you promotional communications, including
            updates about the Program, related investment opportunities,
            community events, or other products and services that may be of
            interest to you (“Marketing Communications”).
          </p>
          <p>
            Such communications may be sent by email, SMS, secure Portal
            messaging, or other electronic means.
          </p>
          <p>
            You may opt out of receiving Marketing Communications at any time
            by:
          </p>
          <ul
            style={{
              listStyleType: "none",
              paddingLeft: "0",
            }}
          >
            <li>(i) Clicking the “unsubscribe” link in any email we send;</li>
            <li>(ii) Replying “STOP” to any SMS message;</li>
            <li>
              (iii) Adjusting your preferences in your Account settings on the
              Portal; or
            </li>
            <li>
              (iv) Contacting us at{" "}
              <a
                className="fw-bold"
                href="mailto:privacy@littlehaitiglobal.com"
              >
                privacy@littlehaitiglobal.com
              </a>
              .
            </li>
          </ul>
          <p>
            Please note that opting out of Marketing Communications will not
            affect your receipt of transactional or administrative messages that
            are necessary for your participation in the Program or the operation
            of your Account.
          </p>

          {/* Section 9 */}
          <h5 className="fw-bold mt-4 mb-2">
            9. Sharing and Disclosure of Personal Information
          </h5>
          <p>
            We do not sell your Personal Information. We may share your Personal
            Information only as described below and in compliance with
            applicable law:
          </p>

          <h5 className="fw-bold mt-3">A. Internal Project Teams</h5>
          <p>
            We may share your Personal Information with LHG’s internal project
            teams, departments, and authorized personnel who require access to
            such information for operational, administrative, or program-related
            purposes. Such access will be limited to those with a legitimate
            need to know and will be subject to confidentiality obligations
            consistent with this Privacy Policy and applicable law.
          </p>

          <h5 className="fw-bold mt-3">B. With Your Consent</h5>
          <p>
            We may share your Personal Information with third parties when you
            have given clear, informed consent to such sharing.
          </p>

          <h5 className="fw-bold mt-3">C. Service Providers and Contractors</h5>
          <p>
            We may engage third-party service providers, contractors, and
            consultants to perform services on our behalf, including payment
            processing, data hosting, IT support, analytics, marketing, and
            compliance screening. These third parties are contractually required
            to process Personal Information only in accordance with our
            instructions and to protect its confidentiality and security.
          </p>

          <h5 className="fw-bold mt-3">D. Program Partners</h5>
          <p>
            We may share Personal Information with Program partners, including
            governmental agencies, investment entities, relocation service
            providers, and other authorized entities involved in the
            administration and execution of the Program.
          </p>

          <h5 className="fw-bold mt-3">E. Legal and Regulatory Disclosures</h5>
          <p>
            We may disclose Personal Information to courts, law enforcement
            authorities, regulators, or other government officials when we
            believe such disclosure is necessary to:
          </p>
          <ul
            style={{
              listStyleType: "none",
              paddingLeft: "0",
            }}
          >
            <li>(i) Comply with legal obligations;</li>
            <li>(ii) Respond to lawful requests;</li>
            <li>
              (iii) Protect the rights, property, or safety of LHG, our Users,
              or others; or
            </li>
            <li>(iv) Enforce our agreements.</li>
          </ul>

          <h5 className="fw-bold mt-3">F. Business Transfers</h5>
          <p>
            In the event of a merger, acquisition, corporate reorganization,
            sale of assets, or bankruptcy, your Personal Information may be
            transferred to a successor entity, subject to this Privacy Policy
            and applicable law.
          </p>

          {/* Section 10 */}
          <h5 className="fw-bold mt-4 mb-2">
            10. International Data Transfers
          </h5>
          <p>
            Your Personal Information may be stored, processed, and transferred
            to servers and facilities located outside of your country of
            residence, including to the United States and other jurisdictions
            where privacy laws may not provide the same level of protection as
            those in your jurisdiction.
          </p>
          <p>
            Where required by applicable law, we will implement appropriate
            safeguards for such transfers, which may include:
          </p>
          <ul
            style={{
              listStyleType: "none",
              paddingLeft: "0",
            }}
          >
            <li>
              (i) Executing the European Commission’s Standard Contractual
              Clauses or UK International Data Transfer Addendum;
            </li>
            <li>
              (ii) Verifying that the recipient is located in a jurisdiction
              deemed to provide adequate protection by the European Commission
              or UK authorities; or
            </li>
            <li>
              (iii) Relying on other lawful transfer mechanisms recognized under
              applicable law.
            </li>
          </ul>
          <p>
            You may request further information about the safeguards applied to
            international transfers by contacting us at{" "}
            <a className="fw-bold" href="mailto:privacy@littlehaitiglobal.com">
              privacy@littlehaitiglobal.com
            </a>
            .
          </p>

          {/* Section 11 */}
          <h5 className="fw-bold mt-4 mb-2">11. Data Security</h5>
          <p>
            LHG implements and maintains commercially reasonable administrative,
            technical, and physical safeguards designed to protect the
            confidentiality, integrity, and availability of Personal
            Information. These safeguards include, without limitation:
          </p>
          <ul
            style={{
              listStyleType: "none",
              paddingLeft: "0",
            }}
          >
            <li>
              (i) Encryption of data in transit (including secure HTTPS
              communications) and at rest;
            </li>
            <li>(ii) Role-based access controls;</li>
            <li>
              (iii) Two-factor authentication (2FA) for system and account
              access;
            </li>
            <li>
              (iv) Firewalls and intrusion detection and prevention systems;
            </li>
            <li>
              (v) Regular vulnerability assessments, system audits, and
              continuous monitoring;
            </li>
            <li>
              (vi) Mandatory staff training on data protection obligations.
            </li>
          </ul>
          <p>
            While LHG takes reasonable steps to protect your Personal
            Information, no method of transmission over the Internet or method
            of electronic storage is entirely secure, and absolute security
            cannot be guaranteed. You are responsible for maintaining the
            confidentiality of your Account credentials and for taking
            appropriate measures to secure your devices, networks, and any
            Personal Information in your control.
          </p>
          <p>
            You agree to notify us promptly at{" "}
            <a className="fw-bold" href="mailto:security@littlehaitiglobal.com">
              security@littlehaitiglobal.com
            </a>{" "}
            if you become aware of, or reasonably suspect, any unauthorized
            access to your Account, the Portal, or the Services, or any other
            actual or suspected breach of security.
          </p>

          {/* Section 11A */}
          <h5 className="fw-bold mt-3">11A. Breach Notification</h5>
          <p>
            In the event of a personal data breach affecting your Personal
            Information, LHG will provide notice to you and, where required, to
            the relevant supervisory or regulatory authorities without undue
            delay, in accordance with applicable law (including, where
            applicable, Articles 33–34 of the GDPR, the CCPA, and other data
            protection laws).
          </p>
          <p>
            Such notification will include, to the extent reasonably available:
          </p>
          <ul
            style={{
              listStyleType: "none",
              paddingLeft: "0",
            }}
          >
            <li>(i) A description of the nature of the breach;</li>
            <li>(ii) The categories of Personal Information affected;</li>
            <li>(iii) The likely consequences of the breach; and</li>
            <li>
              (iv) The measures taken or proposed to address the breach and
              mitigate any potential adverse effects.
            </li>
          </ul>
          <p>
            Where all such information cannot be provided at the same time, LHG
            may provide the information in phases as permitted by law.
          </p>

          {/* Section 12 */}
          <h5 className="fw-bold mt-4 mb-2">12. Data Retention</h5>

          <h5 className="fw-bold mt-3">A. Retention</h5>
          <p>
            We retain Personal Information only for as long as necessary to
            fulfill the purposes for which it was collected, to comply with
            legal and regulatory obligations, to resolve disputes, and to
            enforce our agreements.
          </p>
          <p>
            When determining retention periods, we consider the following
            criteria:
          </p>
          <ul
            style={{
              listStyleType: "none",
              paddingLeft: "0",
            }}
          >
            <li>(i) The nature and sensitivity of the Personal Information;</li>
            <li>
              (ii) The potential risk of harm from unauthorized use or
              disclosure;
            </li>
            <li>
              (iii) The purposes for which we process the Personal Information;
            </li>
            <li>(iv) Applicable legal requirements; and</li>
            <li>(v) Our operational needs.</li>
          </ul>
          <p>
            Once the applicable retention period has expired, we will securely
            delete or anonymize Personal Information, unless we are required by
            law to retain it for a longer period.
          </p>

          <h5 className="fw-bold mt-3">
            B. Retention of Anonymized or Aggregated Data
          </h5>
          <p>
            Notwithstanding Section 12, LHG may create, use, and retain data
            that has been anonymized or aggregated in such a manner that it can
            no longer reasonably be used to identify an individual (
            <strong>“Anonymized Data”</strong>). LHG may use Anonymized Data for
            statistical analysis, research, program evaluation, or other
            legitimate business purposes. Anonymized Data may be retained
            indefinitely, provided it remains de-identified and cannot
            reasonably be re-identified in accordance with applicable law.
          </p>

          {/* Section 13 */}
          <h5 className="fw-bold mt-4 mb-2">
            13. Third-Party Processors and Links
          </h5>
          <p>
            The Portal may include integrations with, or links to, Third-Party
            Sites and services operated by unaffiliated entities. These third
            parties may process Personal Information in accordance with their
            own privacy policies, which we encourage you to review.
          </p>
          <p>
            We are not responsible for the privacy, security, or information
            practices of such third parties, except to the extent required by
            applicable law.
          </p>

          {/* Section 14 */}
          <h5 className="fw-bold mt-4 mb-2">
            14. Children’s Privacy and Age Verification
          </h5>
          <p>
            The Portal and Services are not directed to children under the
            minimum digital consent age for their jurisdiction, as defined in
            the Terms of Use. We do not knowingly collect Personal Information
            from children without verifiable parental or legal guardian consent.
          </p>
          <p>
            Where LHG is required by applicable law to obtain such consent
            before collecting, using, or disclosing Personal Information from a
            child, we will take reasonable steps to confirm it. Verification
            methods may include requiring the parent or guardian to:
          </p>
          <ul
            style={{
              listStyleType: "none",
              paddingLeft: "0",
            }}
          >
            <li>(i) Provide a signed consent form;</li>
            <li>
              (ii) Use a credit card, debit card, or other online payment system
              to confirm identity;
            </li>
            <li>
              (iii) Communicate via a verified telephone call or video
              conference; or
            </li>
            <li>
              (iv) Provide other reliable proof of identity acceptable under
              applicable law.
            </li>
          </ul>
          <p>
            If we become aware that we have collected Personal Information from
            a child in violation of this policy, or if we cannot verify that
            appropriate consent has been obtained, we will promptly delete the
            information and restrict access to the Portal and Services until
            such verification is completed. Parents or legal guardians who
            believe their child has provided Personal Information should contact
            us at{" "}
            <a className="fw-bold" href="mailto:privacy@littlehaitiglobal.com">
              privacy@littlehaitiglobal.com
            </a>
            .
          </p>
          {/* Section 15 */}
          <h5 className="fw-bold mt-4 mb-2">
            15. Your Rights Under Specific Jurisdictions
          </h5>
          <p>
            Depending on your place of residence, you may have additional
            privacy rights under applicable law, including the rights described
            below. LHG will honor these rights to the extent required by
            applicable law.
          </p>

          <h5 className="fw-bold mt-3">A. California Residents (CCPA/CPRA)</h5>
          <p>If you are a California resident, you may have the right to:</p>
          <ul
            style={{
              listStyleType: "none",
              paddingLeft: "0",
            }}
          >
            <li>
              (i) Know what categories and specific pieces of Personal
              Information we have collected about you, the sources from which
              the information was collected, the business or commercial purposes
              for collecting it, and the categories of third parties with whom
              we share it;
            </li>
            <li>
              (ii) Request deletion of your Personal Information, subject to
              certain exceptions;
            </li>
            <li>
              (iii) Request correction of inaccurate Personal Information;
            </li>
            <li>
              (iv) Opt out of the “sale” or “sharing” of Personal Information,
              as those terms are defined under California law;
            </li>
            <li>
              (v) Not be discriminated against for exercising your privacy
              rights.
            </li>
          </ul>
          <p>
            To exercise any of these rights, you may contact us at{" "}
            <a className="fw-bold" href="mailto:privacy@littlehaitiglobal.com">
              privacy@littlehaitiglobal.com
            </a>
            . We will verify your request in accordance with California law,
            which may require proof of identity. You may also designate an
            authorized agent to make requests on your behalf, provided the
            agent’s authority is verified.
          </p>

          <h5 className="fw-bold mt-3">
            B. European Union and United Kingdom Residents (GDPR/UK GDPR)
          </h5>
          <p>
            If you are located in the EU or UK, you have the rights described in
            Section 7 of this Privacy Policy and additional rights to:
          </p>
          <ul
            style={{
              listStyleType: "none",
              paddingLeft: "0",
            }}
          >
            <li>
              (i) Lodge a complaint with your local data protection authority if
              you believe our processing of your Personal Information violates
              applicable law;
            </li>
            <li>
              (ii) Request restriction of processing where you contest the
              accuracy of the Personal Information, the processing is unlawful,
              or you have objected to processing pending verification of
              legitimate grounds.
            </li>
          </ul>

          <h5 className="fw-bold mt-3">C. Canadian Residents (PIPEDA)</h5>
          <p>
            If you are a Canadian resident, you have the right to access the
            Personal Information we hold about you, to request corrections, and
            to challenge our compliance with the principles of the Personal
            Information Protection and Electronic Documents Act (PIPEDA).
          </p>

          <h5 className="fw-bold mt-3">D. Other Jurisdictions</h5>
          <p>
            Residents of other jurisdictions may have similar or additional
            rights under applicable local privacy laws. We will comply with such
            laws where they apply.
          </p>

          <h5 className="fw-bold mt-3">
            E. Jurisdiction-Specific Supplemental Notices
          </h5>
          <p>
            Certain jurisdictions may require LHG to provide additional privacy
            disclosures, notices, or terms specific to your place of residence.
            Where applicable, such notices will be made available through the
            Portal, appended to this Privacy Policy, or provided separately in
            writing. In case of any conflict between this Privacy Policy and a
            jurisdiction-specific notice, the latter shall control to the extent
            required by applicable law.
          </p>

          {/* Section 16 */}
          <h5 className="fw-bold mt-4 mb-2">16. Exercising Your Rights</h5>
          <p>
            To submit a request to exercise any of the rights described in this
            Privacy Policy, you may contact us using either of the following
            methods:
          </p>
          <ul
            style={{
              listStyleType: "none",
              paddingLeft: "0",
            }}
          >
            <li>
              Email:{" "}
              <a
                className="fw-bold"
                href="mailto:privacy@littlehaitiglobal.com"
              >
                privacy@littlehaitiglobal.com
              </a>
            </li>
            <li>
              Mail: Little Haiti Global Inc., Attn: Privacy Officer, 9841
              Washingtonian Blvd Suite 200 #1102, Gaithersburg, MD 20878
            </li>
          </ul>
          <p>When submitting a request, you must:</p>
          <ul
            style={{
              listStyleType: "none",
              paddingLeft: "0",
            }}
          >
            <li>
              (i) Provide sufficient information to allow LHG to reasonably
              verify that you are the individual to whom the Personal
              Information relates, or an Authorized Representative with
              authority to act on that individual’s behalf;
            </li>
            <li>
              (ii) Describe your request with sufficient clarity and detail to
              enable LHG to properly understand, evaluate, and respond to it.
            </li>
          </ul>
          <p>
            If we are unable to verify your identity or authority, we may be
            unable to respond to your request or provide access to the requested
            Personal Information, as permitted by applicable law.
          </p>

          {/* Section 16A */}
          <h5 className="fw-bold mt-3">16A. Verification Standards</h5>
          <p>
            To protect the privacy and security of your Personal Information,
            LHG will take reasonable steps to verify your identity before
            fulfilling any request under Sections 7, 7A, or 15 of this Privacy
            Policy. Verification methods may include, without limitation:
          </p>
          <ul
            style={{
              listStyleType: "none",
              paddingLeft: "0",
            }}
          >
            <li>
              (i) Matching information you provide with information already in
              our records;
            </li>
            <li>(ii) Requesting additional identifying documentation;</li>
            <li>(iii) Using secure verification tools or procedures.</li>
          </ul>
          <p>
            If you designate an Authorized Representative to submit a request on
            your behalf, LHG may require:
          </p>
          <ul
            style={{
              listStyleType: "none",
              paddingLeft: "0",
            }}
          >
            <li>(i) A written, signed authorization from you;</li>
            <li>(ii) Proof of the Authorized Representative’s identity;</li>
            <li>(iii) Verification of your own identity.</li>
          </ul>
          <p>
            Any identification or verification information collected for
            purposes of fulfilling a rights request will be used solely for that
            purpose and will be securely deleted or anonymized once verification
            is complete, unless retention is required by applicable law.
          </p>
          {/* Section 17 */}
          <h5 className="fw-bold mt-4 mb-2">
            17. Changes to this Privacy Policy
          </h5>
          <p>
            We may update or modify this Privacy Policy at any time to reflect
            changes in our practices, technology, legal requirements, or other
            factors. If we make material changes, we will post the updated
            Privacy Policy on the Portal and update the “Last Updated” date at
            the top of this page.
          </p>
          <p>
            Where required by applicable law, we will provide additional notice
            or obtain your consent before material changes take effect. Your
            continued use of the Portal or Services after any changes become
            effective constitutes your acceptance of the revised Privacy Policy.
          </p>

          {/* Section 18 */}
          <h5 className="fw-bold mt-4 mb-2">18. Controlling Language</h5>
          <p>
            This Privacy Policy may be translated into other languages for
            convenience. In the event of any conflict or inconsistency between a
            translated version and the English version, the English version
            shall prevail and control in all respects.
          </p>

          {/* Section 19 */}
          <h5 className="fw-bold mt-4 mb-2">19. Contact Information</h5>
          <p>
            If you have any questions, concerns, or complaints regarding this
            Privacy Policy, or if you wish to exercise your rights under
            applicable data protection laws, you may contact us using the
            following details:
          </p>
          <ul
            style={{
              listStyleType: "none",
              paddingLeft: "0",
            }}
          >
            <li className="fw-bold">Little Haiti Global Inc.</li>
            <li>Attn: Privacy Officer</li>
            <li>
              Email:{" "}
              <a
                className="fw-bold"
                href="mailto:privacy@littlehaitiglobal.com"
              >
                privacy@littlehaitiglobal.com
              </a>
            </li>
            <li>
              Mail: 9841 Washingtonian Blvd Suite 200 #1102, Gaithersburg, MD
              20878
            </li>
          </ul>
          <p>
            If you are located in the European Union or the United Kingdom, you
            may also contact our designated Data Protection Representative at:
            [EU/UK Data Protection Representative contact details, if
            applicable]
          </p>

          {/* Section 19A */}
          <h5 className="fw-bold mt-3">19A. Data Protection Officer</h5>
          <p>
            Where required by applicable law, LHG has appointed a Data
            Protection Officer (<strong>“DPO”</strong>) responsible for
            monitoring our compliance with data protection laws and this Privacy
            Policy. The DPO serves as a point of contact for inquiries,
            complaints, and requests relating to the Processing of Personal
            Information, including matters requiring confidential handling or
            communication with supervisory authorities.
          </p>
          <p className="mb-1 fw-bold">Data Protection Officer Contact:</p>
          <ul
            style={{
              listStyleType: "none",
              paddingLeft: "0",
            }}
          >
            <li>[Name or “Data Protection Officer”]</li>
            <li>
              Email:{" "}
              <a className="fw-bold" href="mailto:dpo@littlehaitiglobal.com">
                dpo@littlehaitiglobal.com
              </a>
            </li>
            <li>
              Mail: 9841 Washingtonian Blvd Suite 200 #1102, Gaithersburg, MD
              20878
            </li>
          </ul>

          {/* Section 20 */}
          <h5 className="fw-bold mt-4 mb-2">20. Effective Date</h5>
          <p>
            This Privacy Policy is effective as of August 12, 2025{" "}
            <strong>and remains in effect until amended or replaced.</strong>
          </p>
        </div>
      </div>
    </>
  );
}
